/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Collapse, IconButton } from '@mui/material'
import { CancelOutlined, HelpOutlineOutlined } from '@mui/icons-material'
import { TypographyCaption } from '../Typography'
import { Breakpoint } from '../../styles/media-breakpoints'

interface Props {
  helpText: string | React.ReactNode
}

export const WithHelp: React.FC<React.PropsWithChildren<Props>> = ({ children, helpText }) => {
  const [isOpen, setOpen] = React.useState(false)
  const { colors } = useTheme()
  return (
    <>
      <Flex>
        {children}
        {helpText && (
          <StyledIconButton title="Toggle help" disableRipple onClick={() => setOpen(!isOpen)}>
            {isOpen ? (
              <CancelOutlined style={{ fontSize: '2rem' }} />
            ) : (
              <HelpOutlineOutlined style={{ fontSize: '2rem' }} />
            )}
          </StyledIconButton>
        )}
      </Flex>

      <Help>
        <Collapse in={isOpen}>
          <TypographyCaption as="p" color={colors.grey.dark}>
            {helpText}
          </TypographyCaption>
        </Collapse>
      </Help>
    </>
  )
}

const Help = styled.div`
  order: 1;
  flex-basis: 100%;
  flex-grow: 1;
  @media (max-width: ${Breakpoint.tablet}) {
    order: 0;
  }
`

const Flex = styled.div`
  display: flex;
`

const StyledIconButton = styled(IconButton)`
  color: ${({ theme }) => theme.colors.primary.medium};
  align-self: flex-start;
`
